/**
 * Formatted Currency Pretty
 *
 * Returns an object populated with a floating point decimal in USD currency format
 * If 'wholeCurrency' is passed as a second argument, then the whole amount will be returned.
 *
 */
export default function formatCurrencyPretty(money, fmt) {
  if (fmt === void 0) {
    fmt = 'currency';
  }
  let format = fmt;
  let actual = parseFloat(money);
  if (format === 'wholeCurrency') {
    actual = Math.ceil(actual);
    format = 'currency';
  }
  return {
    value: actual,
    style: format,
    currency: 'USD'
  };
}